import { render, staticRenderFns } from "./AppfcHome.vue?vue&type=template&id=6742a226"
import script from "./AppfcHome.vue?vue&type=script&lang=js"
export * from "./AppfcHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports